import JSZip from 'jszip';
import * as XLSX from 'xlsx';

// Classification and Unit cost columns are hidden in the UI for now —
// keep them out of the template so users don't try to fill them. The
// parser ignores both columns even if a custom ZIP includes them.
const TEMPLATE_ROWS = [
  {
    Name: 'Mojito Sample',
    Translate: 'Mojito muestra',
    Description: 'Refreshing rum cocktail',
    Image: 'mojito.jpg',
    Logo: 'mojito-logo.png',
    Rating: 4,
    'Initial qty': 100,
    'Restock threshold': 20,
  },
  {
    Name: 'Highball Sample',
    Translate: 'Highball muestra',
    Description: 'Classic whiskey serve',
    Image: 'highball.jpg',
    Logo: '',
    Rating: 3,
    'Initial qty': 80,
    'Restock threshold': 15,
  },
];

const README_TXT = `STOCK IMPORT — README
=====================

Folder structure
----------------
stock-import.zip
├── stock.xlsx        Required. One sheet with the columns below.
└── images/           Optional. Drop product images and logos here.

XLSX columns
------------
Name                Required, min 2 chars
Translate           Optional, ES translation
Description         Optional
Image               Optional. Filename inside images/ (e.g. "mojito.jpg")
                    OR a full http(s) URL to an already-uploaded image.
Logo                Optional. Same rules as Image.
Rating              Optional, integer 1..5 (default 3)
                    Lower rating = lower wheel win probability ( (6-r)^2 ).
Initial qty         Optional, whole number
Restock threshold   Optional, whole number

How duplicates are handled
--------------------------
A row whose Name matches an existing stock item is flagged in the preview.
For each duplicate you'll choose: "Replace existing" or "Add as new".

The Import button stays disabled until all rows are valid. Fix any
errors (missing image, bad rating, etc.) in the XLSX, re-zip, and drop
again.
`;

export async function downloadTemplate(): Promise<void> {
  const zip = new JSZip();

  const ws = XLSX.utils.json_to_sheet(TEMPLATE_ROWS);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Stock');
  const xlsxBuffer = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });

  zip.file('stock.xlsx', xlsxBuffer);
  zip.file('README.txt', README_TXT);
  zip.folder('images');
  zip.file(
    'images/.keep',
    '# Drop your product images and wheel logos here.\n# Reference them by filename in stock.xlsx.\n',
  );

  const blob = await zip.generateAsync({ type: 'blob' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'stock-import-template.zip';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
